import HorizontalTabs from './HorizontalTabs'
export default HorizontalTabs
